<template>
  <canvas ref="canvas" style="max-width: 800px; max-height: 400px; position: relative;"></canvas>
</template>

<script>
import ChartJs from 'chart.js'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

let default_option = {
  responsive: true,
  maintainAspectRatio: true,
  tooltips: {
    enabled: false,
    custom: CustomTooltips,
    intersect: true,
    mode: 'index',
    position: 'nearest',
    callbacks: {
      labelColor: function (tooltipItem, chart) {
        return {
          backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor
        }
      }
    }
  },
  scales: {
    yAxes: [{
      scaleLabel: {
        display: true,
        labelString: 'KWh'
      },
      ticks: {
        beginAtZero: true
      }
    }],
    xAxes: [{
      scaleLabel: {
        display: true,
        labelString: '時間'
      }
    }]
  }
};

export default {
  name: 'HistoryMixedChart',
  props: ['data', 'options'],
  data () {
    return {
      chart: null,
      resizeObserver: null
    }
  },
  mounted () {
    this.renderCustomChart();

    //當容器大小變動時，自動觸發圖表 resize
    this.resizeObserver = new ResizeObserver((entries) => {
      //console.log('Resize triggered:', entries[0].contentRect.width)
      if (this.chart) {
        this.chart.resize();
        this.chart.update(0) // 強制重新 render
      }
    })
    this.resizeObserver.observe(this.$el);
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.destroy();
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  watch: {
    data () {
      this.renderCustomChart();
    }
  },
  methods: {
    renderCustomChart () {
      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.canvas.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'bar', // 使用 bar 做為 base，但 datasets 可混合 type
        data: this.data,
        options: this.options || default_option
      });
    }
  }
}
</script>
